import './App.css';
import { Toaster } from 'react-hot-toast';
import { ConfirmProvider } from './context/ConfirmContext';
import AppRoutes from './routes/AppRoutes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// TEMPORAIREMENT DÉSACTIVÉ : Problème de clonage de Promise avec idb-keyval
// import { persistQueryClient } from '@tanstack/react-query-persist-client';
// import { get, set, del } from 'idb-keyval';
// import type { PersistedClient, Persister } from '@tanstack/react-query-persist-client';

// Configuration du persister personnalisé avec IndexedDB
// TEMPORAIREMENT DÉSACTIVÉ
/*
const createIDBPersister = (idbValidKey: IDBValidKey = 'reactQuery'): Persister => {
  return {
    persistClient: async (client: PersistedClient) => {
      try {
        // Sérialiser et désérialiser pour nettoyer les données non-clonables
        const serialized = JSON.stringify(client);
        const cleaned = JSON.parse(serialized);
        await set(idbValidKey, cleaned);
      } catch (error) {
        console.warn('Failed to persist query client:', error);
        // Ne pas bloquer l'application si la persistance échoue
      }
    },
    restoreClient: async () => {
      try {
        return await get<PersistedClient>(idbValidKey);
      } catch (error) {
        console.warn('Failed to restore query client:', error);
        return undefined;
      }
    },
    removeClient: async () => {
      try {
        await del(idbValidKey);
      } catch (error) {
        console.warn('Failed to remove query client:', error);
      }
    },
  };
};
*/

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Activer la persistance du cache
// TEMPORAIREMENT DÉSACTIVÉ
/*
persistQueryClient({
  queryClient,
  persister: createIDBPersister(),
  maxAge: 1000 * 60 * 60 * 24, // 24 heures
  buster: 'v1', // Incrémenter pour invalider le cache
  dehydrateOptions: {
    shouldDehydrateQuery: (query) => {
      // Ne pas persister les queries avec meta.persist = false
      if (query.meta?.persist === false) return false;

      // Ne pas persister les queries en erreur
      if (query.state.status === 'error') return false;

      // Ne pas persister les queries en cours de chargement
      if (query.state.fetchStatus === 'fetching') return false;

      return true;
    },
  },
});
*/

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfirmProvider>
        <AppRoutes />
        <Toaster position="top-right" />
      </ConfirmProvider>
    </QueryClientProvider>
  );
}

export default App;